export function toggleLegacyChartSearch(iframe) {
  if (!iframe || !iframe.contentWindow || !iframe.src) return;
  const target = new URL(iframe.src, window.location.href);
  if (target.pathname !== '/stockchart') return;
  iframe.contentWindow.postMessage({ type: 'legacy-chart-toggle-search' }, target.origin);
}
